const PageLoader = () => {
    return(
        <div className="d-flex align-items-center justify-content-center min-vh-100 background-gray">
            <h5 className='h5'>Loading ...</h5>
        </div>
    );
};

export default PageLoader;